require.context('../../img/stores', true, /\.(png|jpe?g|gif|svg)$/);

// import '../../img/stores/deposit.png';
// import '../../img/stores/medal.png';
// import '../../img/stores/shipping.png';
// import '../../img/stores/tracking.png';

// import '../../img/stores/bonadiva-logo.png';
// import '../../img/stores/bonadiva-logo-square.png';
// import '../../img/stores/bonadiva-logo-white.png';

// import '../../img/stores/sensities-logo.png';
// import '../../img/stores/sensities-logo-square.png';
// import '../../img/stores/sensities-logo-white.png';

// import '../../img/stores/acs-courier.svg';
// import '../../img/stores/elta-courier.svg';
// import '../../img/stores/geniki-taxydromiki.svg';

// import '../../img/stores/maestro.svg';
// import '../../img/stores/mastercard.svg';
// import '../../img/stores/mastercard-securecode.svg';
// import '../../img/stores/paypal.svg';
// import '../../img/stores/piraeus.svg';
// import '../../img/stores/verified-by-visa.svg';
// import '../../img/stores/visa.svg';

// import '../../img/stores/bonadiva/bonadiva-b1.jpg';
// import '../../img/stores/bonadiva/bonadiva-b3.jpg';
// import '../../img/stores/bonadiva/vibrators.jpg';
// import '../../img/stores/bonadiva/vibrators-2x.jpg';
// import '../../img/stores/bonadiva/aisthisiaka-kallyntika.jpg';
// import '../../img/stores/bonadiva/aisthisiaka-kallyntika-2x.jpg';
// import '../../img/stores/bonadiva/sfines-butt-plugs.jpg';
// import '../../img/stores/bonadiva/sfines-butt-plugs-2x.jpg';
// import '../../img/stores/bonadiva/dildos.jpg';
// import '../../img/stores/bonadiva/dildos-2x.jpg';
// import '../../img/stores/bonadiva/bdsm.jpg';
// import '../../img/stores/bonadiva/bdsm-2x.jpg';
// import '../../img/stores/bonadiva/bonadiva-store.jpg';
// import '../../img/stores/bonadiva/bonadiva-store-2x.jpg';
// import '../../img/stores/bonadiva/bonadiva-placeholder.png';

// import '../../img/stores/sensities/sensities-1.jpg';
// import '../../img/stores/sensities/sensities-2.jpg';
// import '../../img/stores/sensities/sensities-3.jpg';
// import '../../img/stores/sensities/essential-oils.jpg';
// import '../../img/stores/sensities/essential-oils-2x.jpg';
// import '../../img/stores/sensities/fytika-kallyntika.jpg';
// import '../../img/stores/sensities/fytika-kallyntika-2x.jpg';
// import '../../img/stores/sensities/protes-yles-kallyntikon.jpg';
// import '../../img/stores/sensities/protes-yles-kallyntikon-2x.jpg';
// import '../../img/stores/sensities/votanotherapeia.jpg';
// import '../../img/stores/sensities/votanotherapeia-2x.jpg';
// import '../../img/stores/sensities/seminars.jpg';
// import '../../img/stores/sensities/seminars-2x.jpg';
// import '../../img/stores/sensities/sensities-store.jpg';
// import '../../img/stores/sensities/sensities-store-2x.jpg';
// import '../../img/stores/sensities/sensities-placeholder.png';

// import '../../img/stores/sensities/seminars/sensities-seminars-center.jpg';
